export default {
  font: {
    main: `Jost`,
    second: "Markazi Text",
  },
  color: {
    black: "#000",
    white: "#fff",
    grey: "#ded6d6",
    pink: "#f34e9a",
    link: "#11adcf",
    a: "#1d55c4",
    text: "#453838",
  },
  shadow: {
    skeumorphic:
      "10px 10px 20px rgba(0, 0, 0, 0.08), -10px -10px 20px rgba(228, 228, 228, 0.45)",
  },
  breakpoint: {
    mobile: "only screen and (max-width: 768px)",
    tablet: "only screen and (max-width: 992px)",
  },
}
